import { getAll } from 'apis/organizations.api';

const { useMemo } = require('react');
const { useQuery } = require('react-query');

const useGetAllOrganizations = (conds = {}) => {
  const { data: organizationsData, ...rest } = useQuery(['organizations'], () => getAll(), {
    ...conds,
  });

  const organizations = useMemo(() => organizationsData?.data ?? [], [organizationsData]);

  return { data: organizations, ...rest };
};

export default useGetAllOrganizations;
